<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="standardpage tiles">
      <b-card-header>
        <i :class="icon" class="mr-1"></i>
        <!-- <CIcon :name="icon" /> -->
        {{ title }}
      </b-card-header>

      <b-card-body class="px-0">
        <b-row class="px-3 mt-4">
          <b-button-group class="ml-3">
            <b-row no-gutters>
              <b-col class="mr-1" cols="auto">
                <b-button
                  id="wizard"
                  v-b-modal.wizardcomponent
                  squared
                  size="sm"
                  :variant="toolbar_variant"
                  :pressed="selectedComponent == 'Wizard'"
                  @click="$bvModal.show('wizardimport')"
                >
                  <i class="fa fa-magic pr-3"></i>Component
                </b-button>
              </b-col>
              <b-col class="mr-5" cols="auto">
                <b-button
                  id="wizard2"
                  v-b-modal.wizardcomponent2
                  squared
                  size="sm"
                  :variant="toolbar_variant"
                  :pressed="selectedComponent == 'Wizard'"
                  @click="$bvModal.show('wizardimport2')"
                >
                  <i class="fa fa-magic pr-3"></i>Component2
                </b-button>
              </b-col>
              <b-col cols="auto">
                <b-button
                  id="wizardmssql"
                  v-b-modal.wizardmssql
                  squared
                  size="sm"
                  :variant="toolbar_variant"
                  :pressed="selectedComponent == 'Import'"
                  @click="selectedComponent = 'Import'"
                >
                  <i class="fa fa-magic pr-3"></i>Import Wizard MSSQL
                </b-button>
              </b-col>
              <b-col cols="auto">
                <b-button
                  id="wizard"
                  v-b-modal.wizard
                  squared
                  size="sm"
                  :variant="toolbar_variant"
                  :pressed="selectedComponent == 'Wizard'"
                  @click="selectedComponent = 'Wizard'"
                >
                  <i class="fa fa-magic pr-3"></i>Import Wizard
                </b-button>
              </b-col>
            </b-row>
          </b-button-group>
        </b-row>

        <b-modal
          id="wizardmssql"
          title="Import Wizard MSSQL"
          size="xl"
          hide-footer
          :modal-class="{ 'c-dark-theme': $store.state.darkMode }"
        >
          <div>
            <component
              :is="selectedComponent"
              :search="search"
              :refresh="refresh"
              @refreshed="refresh = false"
            />
          </div>
        </b-modal>

        <b-modal
          id="wizard"
          title="Import Wizard"
          size="lg"
          hide-footer
          :modal-class="{ 'c-dark-theme': $store.state.darkMode }"
        >
          <div>
            <component
              :is="selectedComponent"
              :search="search"
              :refresh="refresh"
              @refreshed="refresh = false"
            />
          </div>
        </b-modal>

        <WizardFile />
        <WizardFile2 />
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import Import from "./Import";
import Wizard from "./Wizard";

import WizardFile from "./WizardFile.vue";
import WizardFile2 from "./WizardFile2";

export default {
  name: "Wizards",
  components: {
    Import,
    Wizard,
    WizardFile,
    WizardFile2
  },

  data() {
    return {
      title: "Wizards",
      icon: "fa fa-magic",
      toolbar_variant: "outline-primary",
      busy: false,

      selectedComponent: null,
      search: null,
      refresh: null,
      wizard: {
        first: 0,
        last: 2,
        breadcrumb: true,
        steps: [
          {
            id: 1,
            title: "Step 1",
            filename: null,
            locale: "English (United Kingdom)",
            unicode: false,
            codepage: "65001 (UTF-8)",
            format: "Delimited",
            textqualifier: null,
            headerdelimiter: "{CR}{LF}",
            headerrowstoskip: "0",
            columnnames: true,
            rowdelimiter: "{CR}{LF}",
            columndelimiter: "Comma {,}",
          },
        ],
      },
    };
  },
  watch: {
    refresh: {
      // immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.refresh_time = new Date();
        }
      },
    },
  },
  computed: {
    ...mapGetters(["window", "user"]),
  },
  methods: {
    async layout_refresh() {
      this.refresh = true;
      await this.loadData();
    },
  },
};
</script>

<style>
</style>
